import { useDispatch, useSelector } from 'react-redux'
import { setDrawer, setStage } from 'slices/drawer'
import { Button } from 'components'
import { STATICS } from 'statics'
import { CONNECTION_STATUS_NAME, DRAWER_KEY, NEW_VIRTUAL_SUPPORT_STAGES } from 'app-constants'
import { SignalInfo } from '../signal-info'
import './style.scss'

export function ModemFinish({ connectionStatusData }) {
  const dispatch = useDispatch()
  const {
    virtualSupportMassive: { isMassive },
  } = useSelector(({ massive }) => massive)

  function isConnectionStatusAllowToOpenServiceOrder() {
    const isAllowedToOpenServiceOrderStatus =
      connectionStatusData.status === CONNECTION_STATUS_NAME.BAD_SIGNAL ||
      connectionStatusData.status === CONNECTION_STATUS_NAME.OPTICAL_SIGNAL

    return isAllowedToOpenServiceOrderStatus && !isMassive
  }

  function handleBackButton() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  function handleChatClick() {
    dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.REDIRECT_CHAT))
  }

  function handleOpenNewServiceOrderClick() {
    dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.SELECT_ADDRESS))
  }

  function renderMainActionLabel() {
    if (isConnectionStatusAllowToOpenServiceOrder()) {
      return 'Abrir chamado'
    }

    return 'Falar com atendimento'
  }

  function renderMainActionButton() {
    if (isConnectionStatusAllowToOpenServiceOrder()) {
      return (
        <Button
          className='button-component -large'
          color='primary'
          onClick={handleOpenNewServiceOrderClick}
        >
          {renderMainActionLabel()}
        </Button>
      )
    }
    return (
      <Button className='button-component -large' color='primary' onClick={handleChatClick}>
        {renderMainActionLabel()}
      </Button>
    )
  }

  return (
    <div className='modem-finish'>
      <SignalInfo
        icon={STATICS.MODEM_RESTART}
        iconAlt='Icone de modem reiniciando'
        title='Sua internet voltou a funcionar corretamente?'
      >
        <p className='description'>Deu tudo certo por aí?</p>
        <p className='description'>
          Se a sua internet voltou a funcionar, você pode clicar no botão{' '}
          <strong>&ldquo;encerrar&ldquo;</strong> ali embaxo.
        </p>
        <p className='description'>
          Caso sua internet ainda esteja com instabilidade, clique em{' '}
          <strong>&ldquo;{renderMainActionLabel()}&ldquo;</strong> para que nosso suporte possa te
          ajudar =)
        </p>
      </SignalInfo>
      <div className='actions-container'>
        {renderMainActionButton()}
        <Button
          className='button-component -large'
          color='primary'
          outlined
          onClick={handleBackButton}
        >
          Encerrar
        </Button>
      </div>
    </div>
  )
}
